import { useState, useEffect } from 'react';
import { fetchHomeContent } from './homeApi';
import { HomeData } from './types';

export const useGetHomeContent = () => {
  const [homeData, setHomeData] = useState<HomeData | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadContent = async () => {
      try {
        setIsLoading(true);
        setError(null);
        const response = await fetchHomeContent();

        if (response.status === 200) {
          setHomeData(response.data);
        } else {
          setError('Failed to load home content');
        }
      } catch (err) {
        setError('Error loading home content');
      } finally {
        setIsLoading(false);
      }
    };

    loadContent();
  }, []);

  return { homeData, isLoading, error };
};
